import gql from "graphql-tag";

export const RESET_TWO_FACTOR_AUTHENTICATION = gql`
  mutation resetTwoFactorAuthentication($userId: String!) {
    resetTwoFactorAuthentication(userId: $userId) {
      feedback
    }
  }
`;
